// The list of user agents you're probably looking for is here:
// https://github.com/prerender/prerender-node/blob/07f5ab396b2fc2e855b0a4a643c496c1253f85bf/index.js#L43-L123

export const isPrerender = !!navigator.userAgent.match(/bot|prerender|headless/gi);
